import React, { Component, useState, useEffect } from 'react';
import config from '../Config';
import CoverImage from '../components/CoverImage';

class Style extends Component {  
    
    componentDidMount() {
        document.title = `${config.name} ・ Filosofia`;
    }
    
    render() {

        return (
            <div className='b-light'>
                <div className='relative c-100 vh-85 b-dark p-r d-t'>
                    <CoverImage url='images/style.png' />
                </div>

                <div className='border-wrapper'>
                    <div className='border-card-item'>
                        <div class="b-pattern">
                            <div className='content-wrapper m-c p-tb-5'>

                                <div className='animated-item fade-in-slide-up delay-2 content-wrapper m-c b-light t-a-c'>
                                    <div className='p-1 p-tb-2 border-item'>
                                        <h4 className='uppercase ervasera animated-item fade-in-slide-up'>Dove nasce la mia ispirazione</h4>
                                        <p className='m-t-2 animated-item fade-in-slide-up delay-1'>Immagina di entrare in uno spazio che combina l'eleganza rilassata del Mediterraneo con il fascino autentico dello stile folk e il carattere unico dei pezzi vintage.</p>
                                        <img className='c-40 sm-c-50 m-t-2 m-b-2' src='/images/mediterranean-folk.png' />
                                        <p className='animated-item fade-in-slide-up delay-1'>non è solo un design, è un'esperienza che trasforma la tua casa in una dimensione di calore e serenità. IL MEDITERANEAN FOLK denisce spazio e luce grazie ai toni neutri e caldi,combinati con materiali naturali, creando un ambiente invitante e confortevole.Ogni pezzo vintage e ogni dettaglio architettonico raccontano una storia, rendendo la tua casa davvero unica. L'integrazione di elementi come legno, rattan e grandi piante decorative porta la bellezza della natura all'interno, trasformando ogni spazio in un'oasi di pace. Inne, l'eleganza semplice emerge dalle linee pulite, che si fondono con texture ricche e dettagli artigianali per orire uno stile sosticato.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='relative c-100 vh-85 b-dark p-r d-t'>
                    <CoverImage url='images/style-2.png' />
                </div>

                <div className='border-wrapper'>
                    <div className='border-card-item'>
                        <div class="b-pattern">
                            <div className='content-wrapper m-c p-tb-5'>
                                <div className='animated-item fade-in-slide-up delay-2 content-wrapper m-c b-light t-a-c'>
                                    <div className='p-1 p-tb-2 border-item'>
                                        <img className='c-60 m-b-2' src='/images/mediterranean-fusion.png' />
                                        <p className='animated-item fade-in-slide-up delay-1'>Racchiude un connubio unico tra il calore mediterraneo e l'eleganza contemporanea, esprimendo l'unione di tradizione e ranatezza. Questo design invita a scoprire come il fascino naturale del Mediterranean Folk si trasforma in un ambiente sosticato e contemporaneo, donando agli spazi un'anima autentica, accogliente e intramontabile. La palette e i materiali in questa fusione si vestono di nuova eleganza, sposando il fascino ranato del Parisian Chic. I toni caldi della terra si alleggeriscono, lasciando uno spazio morbido e luminoso, mentre gli stucchi, che nel Mediterranean Folk sono elegantemente materici, si trasformano in dettagli più delicati e sosticati. L'atmosfera accogliente del Mediterraneo incontra il gusto delle linee parigine, creando un equilibrio perfetto tra calore e ranatezza: tessuti naturali come lino e cotone si alternano al velluto, mentre il legno vissuto dialoga con dettagli in ottone spazzolato e arredi dal design senza tempo.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
  }
}

export default Style
